// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ utilities
const { formatAmountObject, getPlainAmountObject } = require('utilities/RACurrencyHelper');
import { getLanguage } from 'core/i18n';

class RAOneLineSymbolAmount extends React.Component {
    render() {
        const amountObjectFormatted = formatAmountObject(getPlainAmountObject(this.props.amountObject), true);

        return (
            <OneLineSymbolAmount
                {...this.props}
                amountObjectFormatted={amountObjectFormatted}
                language={getLanguage()}
            />
        );
    }
}

RAOneLineSymbolAmount.propTypes = {
    amountObject: PropTypes.object.isRequired,
};

module.exports = RAOneLineSymbolAmount;
